import { Section, eType, SectionInitData } from "./Section";
import { GameWorld, eGameObject as eWorldObject } from "../GameWorld";
import { ParcelManager } from "../../Parcel/ParcelManager";



/**
 * Dolni sekce s dodavkou
 */
export class VanBottom extends Section {
    private _vanEntity: pc.Entity;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super("botVan", eType.botVan, false);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(z: number, initData?: SectionInitData): Section {
        super.activate(z, initData);

        // Pridat odberne misto do seznamu odbernych mist
        ParcelManager.instance.addDeliveryPoint(this._vanEntity, z + this._size - 1.8, 1);

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected addObjectEntities(): void {
        let world = GameWorld.instance;

        // Zem
        let e = world.getObjectNewEntity(eWorldObject.ground_0);
        e.setEulerAngles(0, 0, 0);
        e.setLocalPosition(0, 0, 0);
        e.reparent(this._root);

        // Zed
        e = world.getObjectNewEntity(eWorldObject.wall);
        e.setLocalPosition(0, 0, 1.25);
        e.reparent(this._root);

        // Dodavka
        e = world.getObjectNewEntity(eWorldObject.van);
        e.setEulerAngles(0, 0, 0);
        e.setLocalScale(1, 1, 1);
        e.setLocalPosition(0, 0, 0.2);
        e.reparent(this._root);
        this._vanEntity = e;

        // Budova L
        e = world.getObjectNewEntity(eWorldObject.building_2);
        e.setLocalPosition(-2, 0, 0);
        e.reparent(this._root);

        // Budova R
        e = world.getObjectNewEntity(eWorldObject.building_2);
        e.setLocalPosition(2, 0, 0);
        e.reparent(this._root);
    }
}